import * as React from 'react';
import { ReactComponent as Close } from '../../../assets/images/close.svg';
import moment from 'moment';
import { addComma } from 'constants/utils';
import { IPayrollRegisterWeeklyHolidayPayDetail } from '../../../types/payroll-register';

interface Props {
  isVisible: boolean;
  onClose: () => void;
  data: IPayrollRegisterWeeklyHolidayPayDetail[];
  infoDescriptions?: string[];
}

const WeeklyHolidayPayModal: React.FunctionComponent<Props> = ({
  isVisible,
  onClose,
  data,
  infoDescriptions = [
    '주휴수당은 월요일 ~ 일요일의 금액을 차주 월요일에 정산합니다.',
    '주휴수당은 주 15시간 이상 근무 , 소정근로일 개근이 충족되어야 계산됩니다.',
  ],
}) => {
  const onCloseModal = () => {
    onClose();
  };

  const sum = data.reduce((acc, item) => acc + item.pay, 0);

  if (!isVisible) return null;
  return (
    <div className="fixed inset-0 z-[2] flex items-center justify-center">
      {/* Modal Content */}
      <div className="relative z-[1] max-h-[90vh] w-[552px] overflow-y-auto rounded-[12px] bg-white px-9 py-[52px]">
        {/* Close Button */}
        <div className="absolute right-8 top-8">
          <div className="flex h-8 w-8 cursor-pointer items-center justify-center" onClick={onCloseModal}>
            <Close />
          </div>
        </div>

        {/* Header */}
        <div className="mb-8 text-[26px] font-bold leading-9 text-[#333333]">주휴수당 내역</div>

        {/* Body */}
        <div className="flex flex-col gap-[30px]">
          {/* List */}
          <div className="flex w-[472px] flex-col">
            {data.map((item, index) => {
              const isLast = index === data.length - 1;
              return (
                <div
                  key={index}
                  className={`flex w-full items-center gap-5 border-b px-0 py-4 ${
                    isLast ? 'border-[#333333]' : 'border-[#eff0f0]'
                  }`}>
                  <div className="flex min-h-px min-w-px flex-1 flex-col">
                    <p className="w-full text-base font-bold leading-[22px] text-[#505054]">{item.week_no}</p>
                    <p className="w-full text-sm font-medium leading-5 text-[#999999]">
                      {moment(item.start_date).format('YYYY.MM.DD')}~{moment(item.end_date).format('YYYY.MM.DD')}
                    </p>
                  </div>
                  <p className="whitespace-nowrap text-right text-lg font-medium leading-6 text-[#505054]">
                    {addComma(String(item.pay))}원
                  </p>
                </div>
              );
            })}
          </div>

          {/* Total */}
          <div className="flex w-[472px] items-center gap-5">
            <p className="min-h-px min-w-px flex-1 text-base font-bold leading-[22px] text-[#505054]">합계</p>
            <p className="whitespace-nowrap text-right text-lg font-bold leading-6 text-[#075453]">
              {addComma(String(sum))}원
            </p>
          </div>

          {/* Info Box */}
          {infoDescriptions.length > 0 && (
            <div className="flex w-[472px] items-center rounded-[10px] bg-[#f3f3f3] p-5">
              <div className="flex min-h-px min-w-px flex-1 flex-col gap-[10px]">
                <div className="flex w-full items-center gap-[3px]">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="shrink-0">
                    <circle cx="10" cy="10" r="8.75" fill="#505054" stroke="#505054" strokeWidth="0.5" />
                    <circle cx="10" cy="15" r="0.833333" fill="white" />
                    <line
                      x1="10"
                      y1="6.66667"
                      x2="10"
                      y2="12.5"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                  <div className="min-h-px min-w-px flex-1">
                    <p className="text-base font-bold leading-[22px] text-[#505054]">확인해주세요.</p>
                  </div>
                </div>
                <div className="w-full">
                  <ul className="m-0 list-disc pl-[18px]">
                    {infoDescriptions.map((desc, index) => (
                      <li key={index} className="mb-0 text-xs font-medium leading-[18px] text-[#505054]">
                        {desc}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Background Overlay */}
      <div className="fixed inset-0 bg-black/60" onClick={onCloseModal} />
    </div>
  );
};
export default WeeklyHolidayPayModal;
